// 调用 Splitting 动画库
Splitting();


(function () {
    const body = document.body;
    const docEl = document.documentElement;
    
    /* ========= 配置 ========= */
    const CONFIG = {
        threshold: 80,       // 鼠标移动多远触发一张
        followDuration: 0.4, // 跟随缓动时间
        fadeDuration: 0.1,   // 淡出时间
        lerpAmount: 0.1      // 鼠标缓动
    };
    
    const lerp = (a, b, n) => (1 - n) * a + n * b;
    const distance = (x1, y1, x2, y2) => Math.hypot(x2 - x1, y2 - y1);
    
    /* ========= 鼠标坐标 ========= */
    let mousePos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    let cachePos = { ...mousePos };
    let isTrailActive = false;
    
    const getPointerPos = (ev) => {
        if (ev.touches && ev.touches.length) {
            return { x: ev.touches[0].pageX, y: ev.touches[0].pageY };
        }
        return { x: ev.clientX, y: ev.clientY };
    };
    
    const handlePointerMove = (ev) => {
        if (!isTrailActive) return;
        mousePos = getPointerPos(ev);
    };
    
    window.addEventListener("mousemove", handlePointerMove);
    window.addEventListener("touchmove", handlePointerMove, { passive: true });
    
    /* ========= 预加载背景图 ========= */
    const preloadImages = (selector = ".content__img-inner") => {
        const els = [...document.querySelectorAll(selector)];
        const urls = [...new Set(els.map(el => {
            const bg = getComputedStyle(el).backgroundImage;
            return bg && bg !== "none" ? bg.slice(5, -2) : null;
        }).filter(Boolean))];
        
        return Promise.all(urls.map(src => new Promise(res => {
            const img = new Image();
            img.onload = img.onerror = res;
            img.src = src;
        })));
    };
    
    /* ========= 单张图片 ========= */
    class TrailImage {
        constructor(el) {
            this.el = el;
            this.rect = el.getBoundingClientRect();
            window.addEventListener("resize", () => {
                this.rect = el.getBoundingClientRect();
                gsap.set(el, { opacity: 0 });
            });
        }
    }
    
    /* ========= 拖尾核心 ========= */
    class ImageTrail {
        constructor(root) {
            this.root = root;
            this.images = [...root.querySelectorAll(".content__img")].map(el => new TrailImage(el));
            this.total = this.images.length;
            
            this.index = 0;
            this.zIndex = 1;
            this.lastMousePos = { ...mousePos };
            this.activeCount = 0;
            this.idle = true;
            
            this.render = this.render.bind(this);
            this.started = false;
            
            requestAnimationFrame(this.render);
        }
        
        render() {
            if (isTrailActive) {
                const d = distance(mousePos.x, mousePos.y, this.lastMousePos.x, this.lastMousePos.y);
                cachePos.x = lerp(cachePos.x, mousePos.x, CONFIG.lerpAmount);
                cachePos.y = lerp(cachePos.y, mousePos.y, CONFIG.lerpAmount);
                
                if (d > CONFIG.threshold) {
                    this.showNext();
                    this.lastMousePos = { ...mousePos };
                }
            }
            requestAnimationFrame(this.render);
        }
        
        showNext() {
            if (!this.total) return;
          
            this.index = (this.index + 1) % this.total;
            const img = this.images[this.index];
            this.zIndex++;
          
            gsap.killTweensOf(img.el);
          
            const rotate = gsap.utils.random(-6, 6);
            const scale  = gsap.utils.random(0.95, 1.05);
          
            gsap.timeline()
              .set(img.el, {
                zIndex: this.zIndex,
                // ✅ 中心点坐标 = 鼠标点
                x: cachePos.x,
                y: cachePos.y,
                opacity: 0,
                //scale: scale * 0.85,
                //rotate
              })
              .to(img.el, {
                duration: CONFIG.followDuration,
                ease: "power3.out",
                // ✅ 中心点坐标 = 鼠标点
                x: mousePos.x,
                y: mousePos.y,
                opacity: 1,
                scale
              })
              .to(img.el, {
                duration: CONFIG.fadeDuration,
                ease: "power3.in",
                opacity: 0,
                //scale: scale * 1.1
              }, ">0.25");
          }
          
    }
    
    /* ========= 仅 box2 内激活 ========= */
    const box2 = document.querySelector(".box2");
    const trailRoot = document.querySelector(".js-trail");
    
    if (box2 && trailRoot) {
        box2.addEventListener("mouseenter", () => {
            isTrailActive = true;
            cachePos = { ...mousePos };
        });
        
        box2.addEventListener("mouseleave", () => {
            isTrailActive = false;
        });
    }
    
    /* ========= 启动 ========= */
    preloadImages().then(() => {
        body.classList.remove("loading");
        if (trailRoot) new ImageTrail(trailRoot);
    });
    
})();

var wFlag = window.innerWidth > 750

$(()=>{
    //box2
    ScrollTrigger.create({
        trigger:'.box2',
        start:'top top+=20%',
        end:'+=20%',
        scrub:1,
        animation:gsap.timeline()
            .from('.box2_title div',{scale:3})
            .from('.box2_title span',{opacity:0})
            .from('.box2_title p',{opacity:0},'<')
    })

    ScrollTrigger.create({
        trigger:'.box2',
        start:'top top',
        end:'+=20%',
        scrub:1,
        animation:gsap.timeline()
            .from('.box2_text1',{x:'-105%'})
            .from('.box2_text2',{x:'105%'},'<')
    })

    ScrollTrigger.create({
        trigger:'.box2',
        start:'top+=10% top',
        end:'+=0%',
        toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .from('.box2_mask',{opacity:0})
    })

    ScrollTrigger.create({
        trigger:'.box2',
        start:'top top',
        end:'+=60%',
        pin:true,
    })

    new Swiper('.Mbox2Swiper', {
        autoplay:true,
        loop:true,
        autoplay: {
            delay: 1000,//1秒切换一次
        },
    })

    if(!wFlag){
        showUp('.Mbox2_title')
        ScrollTrigger.create({
            trigger:'.box2',
            start:'top top+=15%',
            end:'+=30%',
            scrub:1,
            //markers:true,
            animation:gsap.timeline()
                .to('.Mbox2_text div',{backgroundSize:'100% 100%'})
        })
    }

    //box3
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box3',
            start:'top top+=8%',
            end:'+=20%',
            scrub:1,
            animation:gsap.timeline()
                .from('.box3_img',{scale:0.6})
        })

        ScrollTrigger.create({
            trigger:'.box3',
            start:'top+=40% top+=8%',
            end:'+=20%',
            scrub:1,
            //toggleActions:'play none none reverse',
            animation:gsap.timeline()
                .to('.box3_img',{filter:'brightness(0.4)',duration:0.5})
                .from('.box3_title',{y:'2rem',opacity:0,duration:0.5},'-=50%')
        })

        ScrollTrigger.create({
            trigger:'.box3',
            start:'top top+=8%',
            end:'+=80%',
            pin:true,
        })
    }else{
        showUp('.box3_img')
        showUp('.box3_title')
    }
    
    showUp('.box4_img')
    showUp('.box4_title')
})